module.exports = {"620402001":"人民路街道","620402002":"公园路街道","620402003":"四龙路街道","620402004":"工农路街道","620402005":"纺织路街道","620402100":"水川镇","620402101":"四龙镇","620402102":"王岘镇","620402201":"强湾乡","620402202":"武川乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620402.json
// module id = 3041
// module chunks = 0